import {
  GET_LIST_CHIDELETE,
  GET_LIST_CHIDELETE_SUCCESS,
  GET_LIST_CHIDELETE_FAILURE,
} from "../../actions/DanhSachChiDelete/actionTypes";

const initialState = {
  list: [],
  TongTien: 0,
  SoHopDong: 0,
  getListChiDeleteLoading: false,
};
const getListChiDelete = (state, action) => ({
  ...state,
  getListChiDeleteLoading: true,
});

const getListChiDeleteSuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    list: action.payload.list,
    SoHopDong: action.payload.SoHopDong,
    TongTien: action.payload.TongTien,
    getListChiDeleteLoading: false,
  };
};

const getListChiDeleteFailed = (state, action) => ({
  ...state,
  getListChiDeleteLoading: false,
  list: [],
});
export const listChiDeleteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CHIDELETE:
      return getListChiDelete(state, action);
    case GET_LIST_CHIDELETE_SUCCESS:
      // alert("tuty");
      return getListChiDeleteSuccess(state, action);
    case GET_LIST_CHIDELETE_FAILURE:
      //alert('false')
      return getListChiDeleteFailed(state, action);
    default:
      return state;
  }
};

export default listChiDeleteReducer;
